import { useTheme } from "@/app/providers/ThemeContext";
import logoSvgRaw from "@/assets/img/logo.svg?raw";

type BrandLogoProps = {
  size?: number;
  showWordmark?: boolean;
  textColor?: string;
  textSize?: string;
  gap?: number;
};

const logoSvg = logoSvgRaw
  .replace(/width="512"/, 'width="100%"')
  .replace(/height="512"/, 'height="100%"');

export default function BrandLogo({
  size = 28,
  showWordmark = true,
  textColor,
  textSize = "1rem",
  gap = 9,
}: BrandLogoProps) {
  const { theme } = useTheme();
  // Logo follows the active theme when no explicit color is given:
  // white on dark backgrounds, black on light backgrounds.
  const resolvedColor = textColor ?? (theme === "dark" ? "white" : "black");

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap,
        flexShrink: 0,
      }}
    >
      <span
        style={{
          width: size,
          height: size,
          display: "grid",
          placeItems: "center",
          flexShrink: 0,
          overflow: "hidden",
          color: resolvedColor,
        }}
        dangerouslySetInnerHTML={{ __html: logoSvg }}
      />
      {showWordmark ? (
        <span
          style={{
            fontFamily: "var(--font-display)",
            fontSize: textSize,
            color: resolvedColor,
            letterSpacing: "0.05em",
            lineHeight: 1,
          }}
        >
          LINKEDHASH
        </span>
      ) : null}
    </div>
  );
}
